<sdx-menu-flyout direction="bottom-left">
  <sdx-menu-flyout-toggle>
    <profile-badge
      [image]="thumbnail$ | async"
      [numberOfNotifications]="(allNotifications$ | async)?.length"
    ></profile-badge>
  </sdx-menu-flyout-toggle>
  <sdx-menu-flyout-content class="profile-fly-out-menu">
    <div class="sdx-menu-flyout-content-container">
      <p class="text-align-center profile-fly-out-welcome">{{ 'general.profile.welcome' | translate }}</p>
      <p class="text-align-center profile-fly-out-name">{{ fullName$ | async }}</p>
      <p class="text-align-center profile-fly-out-name">{{ organizationalUnit$ | async }}</p>
      <div class="button-group">
        <button class="button button--primary" (click)="navigateToProfile()">
          {{ 'general.profile.myProfile' | translate }}
        </button>
        <button class="button button--secondary" (click)="logout()">
          {{ 'general.profile.logout' | translate }}
        </button>
      </div>
      <div *ngIf="(newestNotifications | async)?.length > 0" class="divider divider--light-gray full-width-divider">
        <span (click)="clearAllNotifications()">{{ 'profile.popout.clearAll' | translate }}</span>
      </div>
      <ng-container *ngFor="let notification of newestNotifications | async; let isLast = last">
        <profile-notification-entry [notification]="notification"></profile-notification-entry>
        <div *ngIf="!isLast" class="divider divider--light-gray notification-divider"></div>
      </ng-container>
    </div>
  </sdx-menu-flyout-content>
</sdx-menu-flyout>
